const emptyDateObject = {
	year: '',
	month: '',
	day: ''
};

export default emptyDateObject;
